<template>
    <div  class="SirenSocket">
        <el-tooltip class="item" effect="light" :content='showBell?"报警铃声 开启":"报警铃声 关闭"' placement="bottom">
            <div class="sirenIcon" style="margin-right:0" v-on:click="getBell">
                <i class="el-icon-close-notification" v-show="!showBell"></i>
                <i class="el-icon-bell" v-show="showBell"></i>
            </div>
        </el-tooltip>
        <audio ref="audio" :src="audioSrc" loop hidden></audio>
        <el-dialog top="15%" class="dialog" :title="alarmData.title" :class="paused" :visible.sync="dialogAlarm" :close-on-click-modal='false' @close="closeAlarm" width="30%">
            <div v-for="(item,i) in alarmData.dataList" :key="i" class="list">
                <span>{{item.name}}</span>：<span>{{item.value}}</span>
            </div>
            <div v-if="alarmData.button" slot="footer" class="dialog-footer">
                <el-button size="small" type="primary" @click="openUrl">去处理</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
// @ is an alias to /src
import {getToken,getTokenBykey,removeTokenBykey,setTokenBykey} from '@/utils/auth'
// import {timefilters} from "@/common/times";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
export default {
  name: 'Home',
    
  data(){
    return{
        showBell:true,
        getToken:getToken(),
        flag:true,
        audioSrc:require('@/assets/baojing.mp3'),
        staffCode:JSON.parse(getToken()).visualAccount.visualAccountCode,
        path: this.$websocketUrl,
        socket:"",
        audio:"",
        setTimeoutPaused:'',
        lockReconnect: false,//是否真正建立连接
        timeout: 30*1000,//30秒一次心跳
        timeoutObj: null,//心跳心跳倒计时
        serverTimeoutObj: null,//心跳倒计时
        timeoutnum: null,//断开 重连倒计时
        timeAxiosWS: null,
        dialogAlarm:false,
        title:'',
        alarmData:{},
        alarmDataList:[],
        paused:"run"
    }
  },
  beforeDestroy() {
    this.out()
  },
  destroyed() {
    window.removeEventListener('beforeunload', this.updateUnload)
  },
  created(){
    window.addEventListener('beforeunload', this.updateUnload)
    if(getTokenBykey('unload')=="true"){
        if (navigator.userAgent.indexOf('Chrome') > -1){
            this.showBell=false
            removeTokenBykey('unload')
            this.$confirm('报警提示音已关闭, 是否开启?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.getBell()
            }).catch(() => {});
        }
    }
    this.path = this.path+this.staffCode+'|'+new Date().getTime();
    this.websocketInit();
  },
  methods:{
    init(){
    },
    updateUnload(){
        setTokenBykey('unload','true')
    },
    closeAlarm(){
        this.paused='paused'
        this.playAudio(2);
        this.dialogAlarm=false;
        if(this.alarmDataList.length>0){
          setTimeout(() => {
            this.playAudio(1)
            let list=JSON.parse(JSON.stringify(this.alarmDataList))
            this.alarmData=list[0];
            this.dialogAlarm=true;
            this.paused='run';
            this.alarmDataList.shift();
          },300)
        }
    },
    getBell(){
        this.showBell=!this.showBell
        if(this.showBell){
            this.$message.success("已开启报警提示音")
        }else{
            this.$message.error("已关闭报警提示音")
        }
    },
    timeTransmission(){
        var that=this;
        that.timeAxiosWS && clearTimeout(that.timeAxiosWS);
        that.timeAxiosWS = setTimeout(function () {
            //新连接
            that.getAxios("Staff/GetWebSocket").then(resolve=>{
                if(resolve){
                    clearTimeout(that.timeAxiosWS)
                    that.websocketInit();
                }else{
                    that.timeTransmission();
                }
            })
        },30000);
    },
    getAxios(url){
        return new Promise((resolve, reject) => {
            this.$axios({
                method: 'post',
                url: this.$shopUrl+url,
                data: {
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    staffCode: this.staffCode,
                }
            }).then( (response)=> {
                if(response.data.error == 0){
                    resolve(response.data.data);
                }else if(response.data.error == 1){
                    this.$message({type: 'info', message: response.data.message});
                }
            }).catch(function (error) {
                reject(error.data)
            });
        });
    },
    websocketInit:function(){
        if(typeof(WebSocket) === "undefined"){
            alert("您的浏览器不支持socket")
        }else{
            // 实例化socket
            this.socket = new WebSocket(this.path)
            // 监听socket连接
            this.socket.onopen = this.open
            // 监听socket错误信息
            this.socket.onerror = this.error
            // 监听socket消息
            this.socket.onmessage = this.getMessage

            this.socket.onclose=this.close
        }
    },
    
    open: function () {
        console.log("socket连接成功")
        //开启心跳
        this.start();
    },
    error: function () {
        console.log("连接错误")
        //重连
        if(this.$store.state.loginToken){
            this.reconnect();
        }
        
    },
    getMessage: function (msg) {
        console.log(msg.data)
        var data=''
        try {
            JSON.parse(msg.data);
            data=JSON.parse(msg.data);
        } catch(e) {
            data=false;
        }
        if(data){
            this.playAudio(1)
        //   var dataList=[];
          var alarmData={};
          alarmData.url='/DeviceLink/Connector?src=/deviceLink/alarmRecord';
          alarmData.button=false;
        //   switch(data.warnType){
        //     case "XL":
        //       alarmData.title='小乐机器人SOS报警'
        //       dataList.push({name:'用户：',value:data.user.userName})
        //       dataList.push({name:'手机号：',value:data.user.phone})
        //       dataList.push({name:"报警时间：",value:data.sendTime})
        //       break;
        //     case "MESH":
        //       alarmData.title='MESH设备报警'
        //       dataList.push({name:"用户：",value:data.user.userName})
        //       dataList.push({name:'手机号：',value:data.user.phone})
        //       dataList.push({name:"报警时间：",value:data.sendTime})
        //       dataList.push({name:"设备名称：",value:data.deviceName})
        //       dataList.push({name:"设备类型：",value:data.deviceType})
        //       dataList.push({name:"位置：",value:data.zone})
        //       dataList.push({name:"报警信息：",value:data.message})
        //       break;
        //     case "SR_JCD":
        //       alarmData.title='生命体征检测带'
        //       var notifyTypeList=['心率异常','呼吸异常','离床','呼吸暂停']
        //       var warnInfo=data.warnInfo
        //       dataList.push({name:"用户：",value:data.user.userName})
        //       dataList.push({name:'手机号：',value:data.user.phone})
        //       dataList.push({name:"设备号：",value:warnInfo.mac})
        //       dataList.push({name:"预警类型：",value:notifyTypeList[warnInfo.notifyType]})
        //       dataList.push({name:"预警开始时间：",value:timefilters(warnInfo.start)})
        //       dataList.push({name:"预警结束时间：",value:timefilters(warnInfo.stop)})
        //       if((data.warnInfo.value>=1||data.warnInfo.value<=-1)&&data.warnInfo.notifyType<2){
        //         dataList.push({name:"心率呼吸预警状态：",value:warnInfo.value>=1?'过快':'过慢'})
        //       }
        //       break;
        //     case "Tog_Watch":
        //       alarmData.title='小乐手表SOS报警'
        //       dataList.push({name:'用户：',value:data.user.userName})
        //       dataList.push({name:'手机号：',value:data.user.phone})
        //       dataList.push({name:"报警时间：",value:timefilters(new Date())})
        //       break;
        //     case "App":
        //       alarmData.title='乐庭关爱一键求助'
        //       dataList.push({name:'用户：',value:data.user.userName})
        //       dataList.push({name:'手机号：',value:data.user.phone})
        //       dataList.push({name:"报警时间：",value:timefilters(data.warnTime)})
        //       break;
        //     case "NB_Look":
        //       alarmData.title='NB设备报警'
        //       dataList.push({name:'用户：',value:data.user.userName})
        //       dataList.push({name:'手机号：',value:data.user.phone})
        //       dataList.push({name:'设备名称：',value:data.deviceType})
        //       dataList.push({name:'设备号：',value:data.deviceId})
        //       dataList.push({name:'报警时间：',value:data.sendTime})
        //       break;
        //     case "afx_bed":
        //       alarmData.title='乐庭床垫报警'
        //       var bedList=["心率过缓", "心率过速", "呼吸过缓", "呼吸过速", "呼吸暂停","","离床超时"]
        //       dataList.push({name:'用户：',value:data.user.userName})
        //       dataList.push({name:'手机号：',value:data.user.phone})
        //       var massage=JSON.parse(data.massage)
        //       dataList.push({name:'报警类型：',value:bedList[massage.WaringType]})
        //       dataList.push({name:'报警时间：',value:massage.MessageDate})
        //       break;
        //   }
          if(data && data.dataList.length>0){
            alarmData.title=data.title;
            alarmData.dataList=data.dataList;
            if(this.dialogAlarm==true){
              this.alarmDataList.push(alarmData)
            }else{
              this.alarmData=alarmData;
              this.paused='run'
              this.dialogAlarm=true;
            }
          }
        }
        this.reset();
    },
    playAudio(type){
        switch (type) {
            case 1://播放音频
                if(this.$refs.audio.paused&&this.showBell){
                    this.$refs.audio.load()
                    this.$refs.audio.play()
                }
                break
            case 2://暂停音频
                this.$refs.audio.pause()
                break
        }
    },
    dingshiPaused(){
        var that=this
        this.setTimeoutPaused=setTimeout(function() {
        that.playAudio(2);
        },30000)
    },
    close: function () {
        console.log("socket已经关闭")
        //重连
        this.reconnect();
    },
    websocketsend(msg) {//向服务器发送信息
            //数据发送
            this.socket.send(msg);
    },
    reconnect() {//重新连接
        var that = this;
        if(that.lockReconnect) {
            return;
        }
        that.lockReconnect = true;
        //没连接上会一直重连，设置延迟避免请求过多\
        
        that.timeoutnum && clearTimeout(that.timeoutnum);
        that.timeoutnum = setTimeout(function () {
            //新连接
            that.websocketInit();
            that.lockReconnect = false;
        },5000);
    },
    reset(){//重置心跳
        var that = this;
        //清除时间
        clearTimeout(that.timeoutObj);
        clearTimeout(that.serverTimeoutObj);
        //重启心跳
        that.start();
    },
    start(){//开启心跳
        var self = this;
        self.timeoutObj && clearTimeout(self.timeoutObj);
        self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
        self.timeoutObj = setTimeout(function(){
            //这里发送一个心跳，后端收到后，返回一个心跳消息，
            if (self.socket.readyState == 1) {//如果连接正常
                let jsonObj = {userName:self.staffCode,msg:"heartCheck"};
                self.socket.send(JSON.stringify(jsonObj));
            }else{//否则重连
                self.reconnect();
            }
            self.serverTimeoutObj = setTimeout(function() {
                //超时关闭
                self.socket.close();
            }, self.timeout);
        }, self.timeout)
    },
    destroyed () {
        console.log('sas')
        // 销毁监听
        this.socket.close()
    },
    out(){
        this.destroyed()
        clearTimeout(this.timeoutObj);
        clearTimeout(this.serverTimeoutObj);
        this.lockReconnect = true;
    }
  },
}
</script>
<style lang="scss" scoped>
    .sirenIcon{
        position: fixed;
        top: 4px;
        right: 160px;
        z-index: 1000;
        font-size: 20px;
        color: #2FBFFA;
        cursor: pointer;
        
    }
    .run{
        animation: myfirst 1.5s infinite;
      }
      @keyframes myfirst{
          0% {
            background:  #eb070713;
          }
          50% {
            background:  #ee49494d;
          }
          100% {
            background:  #eb070713;
          }
      }
       .dialog /deep/ .el-dialog{
        border-radius: 8px;
        .el-dialog__body{
          padding:  0px 20px 10px;
        }
        .el-dialog__footer{
          padding: 0px 20px 10px;
        }
      }
      .dialog /deep/ .el-dialog{
            background: #fff !important;
        }
         .dialog /deep/ .el-dialog__body {
            padding:0 20px 20px !important;
        }
         .dialog /deep/ .el-dialog__header{
            padding:20px !important;
        }
         .dialog /deep/ .el-dialog__headerbtn{
            z-index: 1;
            font-size: 20px !important;
            right: 16px;
        }
         .dialog /deep/ .el-dialog__headerbtn .el-dialog__close{
            color: rgb(143, 149, 150) !important;
            border:none !important;
            // border: 1px solid transparent ;
            // border-radius: 5px;
            // padding: 2px 2px 6px 6px;
            // border-bottom-left-radius: 50px;
            // border-bottom-left-radius: 5px;
            // border-bottom-left-radius: 40px;
            z-index: 20;
        }
    .list{
        line-height: 30px;
      }
</style>